import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ItemDataShapeProps } from 'store/types'

function PostItemText({ icon, color }: ItemDataShapeProps) {
  return (
    <div
      className='w-full h-full overflow-hidden'
      style={{
        color
      }}>
      <div className='flex flex-col items-center justify-center h-full'>
        <FontAwesomeIcon className='w-full h-full' icon={icon} size='xl' />
      </div>
    </div>
  )
}

export default PostItemText
